import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import LinkBar from "../../LinkBar/LinkBar";
import Search from "../Search/Search";
import "./Collections.css";

const Collections = () => {
  const [serieses, setSerieses] = useState([]);
  useEffect(() => {
    fetch("https://apichothaon1-hzrifat.b4a.run/serieses")
      .then((res) => res.json())
      .then((data) =>
        setSerieses(
          data?.map((d) => {
            return d?.name;
          })
        )
      );
  }, []);
  return (
    <div className="container row">
      <div className="col-md-4 col-sm-6 col-12 ms-0 ps-0">
        <Search />
      </div>
      <div className="col-md-8 col-sm-6 col-12">
        <LinkBar />
        <div className="row mt-5 mb-4 ">
          {serieses?.length
            ? serieses?.map((s, i) => {
                return (
                  <div
                    key={i}
                    className="col-md-3 col-sm-6 col-12 d-flex justify-content-center"
                  >
                    <Link
                      style={{ textDecoration: "none" }}
                      exact
                      to={`/collections/${s}`}
                    >
                      <div className="folder-style">
                        <i
                          style={{ fontSize: "5rem" }}
                          className="fa-solid fa-folder"
                        ></i>
                        <p style={{ fontWeight: "500", fontSize: "1.1rem" }}>
                          {s} Series
                        </p>
                      </div>
                    </Link>
                  </div>
                );
              })
            : null}
        </div>
      </div>
    </div>
  );
};

export default Collections;
